import { render, staticRenderFns } from "./QuotaAdd.vue?vue&type=template&id=35eace99&scoped=true"
import script from "./QuotaAdd.vue?vue&type=script&lang=js"
export * from "./QuotaAdd.vue?vue&type=script&lang=js"
import style0 from "./QuotaAdd.vue?vue&type=style&index=0&id=35eace99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35eace99",
  null
  
)

export default component.exports